import qs from 'qs';

const axios = window.axios;
const $ = window.$;
const _ = window._;

$(() => {
  const $emailCheckerResult = $('.page_password_checker .email_checker_result');
  const $emailCheckerResultText = $('.page_password_checker .email_checker_result_text');
  const $postResult = $('.page_password_checker .post_result');

  const emailDisplayFunc = ({isError, message, loading = false}) => {
    const $emailCheckerInput = $('.page_password_checker .password_checker_email');

    if (loading) {
      $emailCheckerInput.addClass('loading');
    } else {
      $emailCheckerInput.removeClass('loading');
      $emailCheckerResultText.text(message);
      if (isError) {
        $emailCheckerInput.addClass('error');
        $emailCheckerInput.removeClass('is-valid');
        $emailCheckerResult.addClass('badresult-text');
        $postResult.hide();
        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'email_error', 'Email validation Error', location.href, {nonInteraction: true});
        }
      } else {
        $emailCheckerInput.addClass('is-valid');
        $emailCheckerInput.removeClass('error');
        $emailCheckerResult.removeClass('badresult-text');
        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'email_valid', 'Email validation OK', location.href, {nonInteraction: true});
        }
      }
    }
    if (document.getElementById('password') != null) {
      if ($('.page_password_checker .password_checker_user_name').hasClass('is-valid')
          && $('.page_password_checker .password_checker_email').hasClass('is-valid')
          && $('.page_password_checker .password_checker_input').hasClass('is-valid')) {
        $('.signup-btn-form-submit').attr('disabled', false);
      }
    } else {
      if ($('.page_password_checker .password_checker_user_name').hasClass('is-valid')
          && $('.page_password_checker .password_checker_email').hasClass('is-valid')) {
        $('.signup-btn-form-submit').attr('disabled', false);
      }
    }
  };

  let emailCancelRequest = null;
  const emailValidateFunc = _.debounce(async(email) => {
    // 前回のリクエストをキャンセルする
    if (emailCancelRequest) {
      emailCancelRequest();
    }
    try {
      emailDisplayFunc({loading: true});
      const data = {
        email: email
      };
      const options = {
        method: 'POST',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify(data),
        cancelToken: new axios.CancelToken(c => { emailCancelRequest = c; }),
        url: '/signup/email/validate'
      };
      const {data: {errors} } = await axios(options);
      if (errors) {
        emailDisplayFunc({isError: true, message: errors[0].message});
      } else {
        emailDisplayFunc({isError: false, message: ''});
      }
    } catch (e) {
      // 何もしない
    }
  }, 150);

  let keepEmailValue = '';
  const emailCheckFunc = () => {
    const email = $('.page_password_checker .password_checker_email').val();

    if (!email || !email.length) {
      emailDisplayFunc({isError: true, message: 'Please enter your email.'});
      return;
    }
    if (keepEmailValue == email) {
      return;
    }

    emailValidateFunc(email);
  };

  const setEmailCheckFunc = ($element) => {
    $element.on('blur', emailCheckFunc);
  };
  const emailKeepFunc = () => {
    keepEmailValue = $('.page_password_checker .password_checker_email').val();
  };
  const setKeepEmailFunc = ($element) => {
    $element.on('focus', emailKeepFunc);
  };

  const $target = $('.page_password_checker .password_checker_email');
  setEmailCheckFunc($target);
  // 表示時に入力済の場合はチェックする
  if ($target.val() != '') $target.trigger('blur');
  setKeepEmailFunc($target);
});
